// Firebase configuration
// Get these values from: Firebase Console > Project Settings > General > Your apps > SDK setup
// After creating your Firebase project, replace the placeholders below.

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB4GhAXFyuXGKyKAPwwpX8ZSloUW2ePTJs",
  authDomain: "sunjin-webapp.firebaseapp.com",
  projectId: "sunjin-webapp",
  storageBucket: "sunjin-webapp.firebasestorage.app",
  messagingSenderId: "184669263572",
  appId: "1:184669263572:web:4f0b2c0a9a4cefa167cd41"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
